import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForShopifyStoreComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'storeId', 'cmsModified'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'storeId',
      isMainColumn: true,
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
